module.exports = __webpack_public_path__ + "lp/img/vote_verygood_active.b9325e14.svg";